import React from 'react';
import { motion } from 'framer-motion';
import { Loader2 } from 'lucide-react';

const ToolCard = ({ 
  tool, 
  onClick, 
  isLoading = false, 
  children = null,
  className = ""
}) => {
  const handleClick = () => {
    if (onClick && !isLoading) {
      onClick(tool);
    }
  };

  return (
    <motion.div
      className={`card flex flex-col p-6 transition-colors hover:border-gray-300 dark:hover:border-white/15 ${className}`}
    >
      <div className="mb-2 flex items-center gap-2.5">
        <tool.icon className="h-5 w-5 flex-shrink-0 text-primary-600 dark:text-primary-400" />
        <h4 className="text-base font-semibold text-gray-900 dark:text-gray-100">{tool.label}</h4>
      </div>
      
      <p className="mb-5 flex-1 text-sm text-gray-600 dark:text-gray-400">{tool.description}</p>
      
      {children || (
        <button
          disabled={isLoading}
          onClick={handleClick}
          className="btn btn-secondary w-full"
        >
          {isLoading ? (
            <Loader2 className="h-4 w-4 animate-spin" />
          ) : (
            <>
              <tool.icon className="h-4 w-4" />
              {tool.action || 'Test'}
            </>
          )}
        </button>
      )}
    </motion.div>
  );
};

export default ToolCard;
